<template>
  <div class="documents-scanner-view">
    <iframe
      ref="homedayLensIframe"
      :src="homedayLensUrl"
      title="Homeday Lens"
      frameborder="0"
      allow="camera;fullscreen;layout-animations 'none'; unoptimized-images 'none'; oversized-images 'none'; sync-script 'none'; sync-xhr 'none'; unsized-media 'none';"
      @load="openFullscreen"
    ></iframe>
  </div>
</template>

<script>
import { sendEvent, EVENTS } from '@/services/gtm';
import ROUTE_NAMES from '@/router/scanner/ROUTE_NAMES';

const MESSAGE_TYPES = {
  EXIT_SCAN: 'EXIT_SCAN',
  SAVE_SCAN: 'SAVE_SCAN',
};

export default {
  name: 'DocumentsScannerView',
  data() {
    return {
      scannedDocument: null,
      homedayLensUrl: process.env.VUE_APP_HD_LENS,
    };
  },
  created() {
    sendEvent(EVENTS.START_SCAN);
  },
  mounted() {
    window.addEventListener('message', this.onMessageReceived);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.onMessageReceived);
  },
  methods: {
    openFullscreen() {
      const { homedayLensIframe } = this.$refs;
      if (!homedayLensIframe) return;
      if (homedayLensIframe.requestFullscreen) {
        homedayLensIframe.requestFullscreen();
      } else if (homedayLensIframe.webkitRequestFullscreen) {
        /* Safari */
        homedayLensIframe.webkitRequestFullscreen();
      } else if (homedayLensIframe.mozRequestFullScreen) {
        /* Firefox */
        homedayLensIframe.mozRequestFullScreen();
      } else if (homedayLensIframe.msRequestFullscreen) {
        /* IE11 */
        homedayLensIframe.msRequestFullscreen();
      } else if (homedayLensIframe.webkitEnterFullscreen) {
        /* iPhone */
        homedayLensIframe.webkitEnterFullscreen();
      }
    },
    closeFullscreen() {
      const { homedayLensIframe } = this.$refs;
      if (!homedayLensIframe) return;
      if (homedayLensIframe.exitFullscreen) {
        homedayLensIframe.exitFullscreen();
      } else if (homedayLensIframe.webkitExitFullscreen) {
        /* Safari */
        homedayLensIframe.webkitExitFullscreen();
      } else if (homedayLensIframe.mozExitFullScreen) {
        /* Firefox */
        homedayLensIframe.mozExitFullScreen();
      } else if (homedayLensIframe.msExitFullscreen) {
        /* IE11 */
        homedayLensIframe.msExitFullscreen();
      }
    },
    onMessageReceived({ data }) {
      if (data.type === MESSAGE_TYPES.EXIT_SCAN) {
        this.closeFullscreen();
        this.$router.push({
          name: ROUTE_NAMES.SCAN_DOCUMENTS,
          query: this.$route.query,
        });
      } else if (data.type === MESSAGE_TYPES.SAVE_SCAN) {
        sendEvent(EVENTS.SAVE_SCAN);
        this.closeFullscreen();
        const { name, content } = data;
        this.$router.push({
          name: ROUTE_NAMES.SCAN_DOCUMENTS,
          query: {
            ...this.$route.query,
            name,
            content,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.documents-scanner-view {
  iframe {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: black;
    padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom)
      env(safe-area-inset-left);
  }
}
</style>
